import React, { useRef, useState } from "react";
import { Icon, Input, Tag } from "antd";
import style from "./index.module.scss";
import classNames from "classnames";

interface InputTagProps {
    className?: string;
    onSubmit: (text: string) => void;
}

export default function InputTag({ onSubmit, className }: InputTagProps) {
    const inputRef = useRef<any>(null);
    const [inputVisible, setInputVisible] = useState(false);
    const [text, setText] = useState("");

    function showInput() {
        setInputVisible(true);
        setText("");
        setTimeout(() => inputRef.current.focus());
    }

    function submitChange() {
        setInputVisible(false);
        onSubmit(text);
    }

    return (
        <div className={classNames(style.root, className)}>
            {inputVisible && (
                <Input
                    ref={inputRef}
                    type="text"
                    size="small"
                    maxLength={500}
                    value={text}
                    className={style.input}
                    onChange={e => setText(e.target.value)}
                    onBlur={submitChange}
                    onPressEnter={submitChange}
                />
            )}

            {!inputVisible && (
                <Tag onClick={showInput} className={style.addTag}>
                    <Icon type="plus" /> 添加标签
                </Tag>
            )}
        </div>
    );
}
